<template>
  <section class="app-main">
<!--    <router-view v-slot="{ Component }">-->
<!--      <transition name="fade-transform" mode="out-in">-->
<!--        <keep-alive :include="cachedViews" :max="10">-->
<!--          <component :is="Component" />-->
<!--        </keep-alive>-->
<!--      </transition>-->
<!--    </router-view>-->
    <router-view v-if="$route.meta.noCache"></router-view>
    <router-view v-slot="{ Component }" v-else>
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </section>
</template>

<script>
export default {
  computed: {
    cachedViews() {
      return this.$store.state.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*min-height: 100%;*/
  /*background-color: #ffffff;*/
  /*margin: 16px;*/
  /*padding: 24px;*/

}
</style>
